'use client';

// `<ShareModal directChannel='x' />` mode — clones the trigger element and
// attaches a click handler that fires the channel intent in place. Skips the
// modal entirely. Used by surfaces with intrinsic single-channel UX (e.g.
// the gift "Thank on X" CTA). Internal — not exported from the lib.
import { c as _c } from "react/compiler-runtime";
import { cloneElement, isValidElement, type MouseEvent, type ReactNode } from 'react';
import type { ShareSurface } from './events';
import type { ShareChannel } from './intents';
import { openShareIntent } from './share';
interface ClickableElementProps {
  onClick?: (e: MouseEvent) => void;
}
export interface ShareDirectTriggerProps {
  trigger: ReactNode;
  channel: ShareChannel;
  url: string;
  text?: string;
  surface: ShareSurface;
  onShared?: (channel: ShareChannel) => void;
}
export function ShareDirectTrigger(props) {
  const $ = _c(11);
  let t0;
  if ($[0] !== props) {
    t0 = () => {
      openShareIntent(props.channel, {
        url: props.url,
        ...(props.text !== undefined ? {
          text: props.text
        } : {}),
        surface: props.surface
      });
      props.onShared?.(props.channel);
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fire = t0;
  if (isValidElement(props.trigger)) {
    const original = props.trigger.props.onClick;
    let t1;
    if ($[2] !== fire || $[3] !== original) {
      t1 = e => {
        if (original !== undefined) {
          original(e);
        }
        if (!e.defaultPrevented) {
          fire();
        }
      };
      $[2] = fire;
      $[3] = original;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    const onClick = t1;
    let t2;
    if ($[5] !== onClick || $[6] !== props.trigger) {
      t2 = cloneElement(props.trigger, {
        onClick
      });
      $[5] = onClick;
      $[6] = props.trigger;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t1;
  if ($[8] !== fire || $[9] !== props.trigger) {
    t1 = <button type="button" onClick={fire} className="contents">{props.trigger}</button>;
    $[8] = fire;
    $[9] = props.trigger;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}